import { render, staticRenderFns } from "./SaleRecovery.vue?vue&type=template&id=20c5249e&"
import script from "./SaleRecovery.vue?vue&type=script&lang=js&"
export * from "./SaleRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports